import { pyStr } from "@Sk";
import { Component, ComponentConstructor } from "@runtime/components/Component";
import { initNativeSubclass } from "@runtime/runner/py-util";
import { Slot } from "@runtime/runner/python-objects";

export interface SlotPlaceholder extends Component {
    _SlotPlaceholder: {
        name: string;
        slot: Slot;
        element: HTMLDivElement;
    };
}

interface SlotPlaceholderConstructor extends ComponentConstructor {
    new (): SlotPlaceholder;
}

export const SlotPlaceholder: SlotPlaceholderConstructor = Sk.abstr.buildNativeClass("anvil.SlotPlaceholder", {
    base: Component,
    constructor: function SlotPlaceholder() {},
    slots: {
        tp$new(args: [pyStr, Slot], kws) {
            const self = Component.prototype.tp$new.call(this, []) as SlotPlaceholder;
            const [pyName, slot] = args;
            const element = document.createElement("div");
            element.innerHTML = `<span style='font-family: monospace'>&lt;Empty Slot:${pyName}&gt;</span>`;
            self._SlotPlaceholder = { name: pyName.toString(), slot, element };
            return self;
        },
    },
    proto: {
        anvil$hookSpec: {
            setupDom() {
                return this._SlotPlaceholder.element;
            },
            getDomElement() {
                return this._SlotPlaceholder.element;
            },
            // getDesignInfo and updateDropMode logic handled at a higher level, because this isn't
            // a real component
        },
    },
    flags: {
        sk$klass: true,
    },
});

initNativeSubclass(SlotPlaceholder);
